import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiConfig from "../axiosConfig";
export const fetchAssets = createAsyncThunk("assetManagement/fetchAssets",
	async () => {
		const response = await apiConfig.get("asset-management/assets");
		const data = await response.data;
		console.log(data)
		return response;
	}
);
export const updateAsset = createAsyncThunk("assetManagement/updateAsset", async ({ assetId, selectedFile, headers }) => {
	const formData = new FormData();
	try {
		formData.append("file", selectedFile, selectedFile.name);
	} catch (error) {
		console.log(error);
	}
	const response = await apiConfig.post(`/asset-management/assets/${assetId}`, formData, {
		headers,
	});
	const data = await response.data;
	return data;
});
const assetManagementSlice = createSlice({
	name: "assetManagement",
	initialState: {
		assets: [],
		status: null,
		error: null,
	},
	reducers: {},
	extraReducers: {
		[fetchAssets.pending]: (state) => {
			console.log("Pending")
			state.status = "loading";
		},
		[fetchAssets.fulfilled]: (state, action) => {
			const response = action.payload.data;
			console.log(response)
			if (response.status === "OK") {
				state.status = "OK";
				state.assets = action.payload.data.data;
			} else {
				state.status = "failed";
				//state.error = action.error.message;
			}
		},
		[fetchAssets.rejected]: (state, action) => {
			state.status = "failed";
			state.error = action.error.message;
		},
		[updateAsset.fulfilled]: (state, action) => {
			const response = action.payload;
			console.log(response)

			if (response.status === "OK") {
				const itemIndex = state.assets.findIndex((item) => item.id === action.payload.data.id);
				state.assets[itemIndex] = action.payload.data;
			}
			else {
				state.status = "failed";
				state.error = action.error.message;
			}
		},
	},
});
export const assetManagementActions = assetManagementSlice.actions;
export default assetManagementSlice.reducer;
